var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobiliti6Yellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 57,
    viewBox: "0 0 72 57",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.7878 12.2382C21.5545 -3.9101 0.988773 -7.84953 0.98877 24.0129C0.988765 73.1307 38.4888 52.7527 57.9555 47.6516C82.9392 41.1048 69.0055 22.3015 50.7878 12.2382Z",
    fill: "#ffc12f",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.45 11.9666C35.6459 7.20143 38.2492 3.74585 38.2492 3.74585C38.2492 3.74585 55.705 26.9161 55.705 35.9964C55.705 45.0768 47.8898 52.4379 38.2492 52.4379C28.6087 52.4379 20.7935 45.0768 20.7935 35.9964C20.7935 33.6223 21.9867 29.2497 23.7494 25.8785M29.0956 17.0255C29.2388 16.812 29.3807 16.6011 29.5214 16.3932",
    stroke: "#ffc12f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#55a12e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6079 46.872C44.7472 45.2966 47.3777 42.7829 49.1621 39.791",
    stroke: "#ffc12f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#55a12e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3345 8.17236H57.0483",
    stroke: "#ffc12f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#55a12e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4178 8.17236H62.0835",
    stroke: "#ffc12f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#55a12e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3911 49.9078H62.4194",
    stroke: "#ffc12f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#55a12e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0522 33.4669H14.0805",
    stroke: "#ffc12f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#55a12e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobiliti6Yellow);
export default __webpack_public_path__ + "static/media/mobiliti_6_yellow.3e0ba77db77088653e990018b3d0a6d9.svg";
export { ForwardRef as ReactComponent };